import { z } from 'my-zod'
import { Iso, instantFns, dateTimeFns } from 'iso-fns2'
import ExternalTimezone from '@marcatopartners/timezone-enum'
import { enumOptionsToObject } from './enum-helpers'

export type Timezone = `${ExternalTimezone}`
export const TimezoneOptions = Object.values(ExternalTimezone).sort() as Timezone[]

export const TimeZoneEnum = z.enum(TimezoneOptions as unknown as readonly [string, ...string[]]) as unknown as z.ZodEnum<
  [Timezone, ...Timezone[]]
>

export const Timezones = enumOptionsToObject(TimezoneOptions)

// This helper function takes in a timezone and returns the corresponding IANA friendly Timezone
// For example, "US/Central" would be converted to "America/Chicago"
export function getIANATz(startingTZ: Timezone) {
  switch (startingTZ) {
    case 'US/Eastern':
      return 'America/New_York'
    case 'US/Pacific':
      return 'America/Los_Angeles'
    case 'US/Central':
      return 'America/Chicago'
    case 'US/Michigan':
      return 'America/Detroit'
    case 'US/Mountain':
      return 'America/Denver'
    case 'US/Arizona':
      return 'America/Phoenix'
    case 'US/Hawaii':
      return 'Pacific/Honolulu'
    case 'US/Alaska':
      return 'America/Anchorage'
    default:
      return startingTZ
  }
}

export function getSystemTZFromIANA(ianaTZ: string): Timezone {
  switch (ianaTZ) {
    case 'America/New_York':
      return 'US/Eastern'
    case 'America/Chicago':
      return 'US/Central'
    case 'America/Detroit':
      return 'US/Michigan'
    case 'America/Denver':
      return 'US/Mountain'
    case 'America/Los_Angeles':
      return 'US/Pacific'
    case 'America/Anchorage':
      return 'US/Alaska'
    case 'America/Phoenix':
      return 'US/Arizona'
    case 'Pacific/Honolulu':
      return 'US/Hawaii'
    default:
      // @ts-ignore
      return ianaTZ
  }
}

export function formatInstantWithTimezone(instant: Iso.Instant, timezone: Timezone, formatString: string): string {
  return dateTimeFns.format(instantFns.chain(instant).toZonedDateTime(timezone).toDateTime().value(), formatString)
}
